import type { FC } from 'react';
import { memo, useCallback, useEffect } from 'react';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';
import ModalBody from '@trend-dev/trendtech-ui/components/UI/Modal/ModalBody';
import ModalDialog from '@trend-dev/trendtech-ui/components/UI/Modal/ModalDialog';
import ModalFooter from '@trend-dev/trendtech-ui/components/UI/Modal/ModalFooter';
import ModalHeader from '@trend-dev/trendtech-ui/components/UI/Modal/ModalHeader';

import { useControlStore } from 'store/controls';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import { useLeaveConference } from 'hooks/useLeaveConference';

import { acceptText, cancelText, text, title } from './const';
import styles from './styles.module.scss';

const LeaveModal: FC = () => {
    const { controls, hideLeaveModal } = useControlStore();
    const leaveConference = useLeaveConference();
    const { triggerYM } = useYM();
    const isOpen = controls.leave;

    const handleAccept = useCallback(() => {
        leaveConference();
        triggerYM({ goal: GoalType.CONFERENCE_PAGE_EXIT_CONFIRMATION_ACCEPT });
    }, [leaveConference]);

    const handleDecline = useCallback(() => {
        hideLeaveModal();
        triggerYM({ goal: GoalType.CONFERENCE_PAGE_EXIT_CONFIRMATION_CLOSE });
    }, []);

    useEffect(() => {
        if (isOpen) triggerYM({ goal: GoalType.CONFERENCE_PAGE_EXIT_CONFIRMATION });
    }, [isOpen]);

    return (
        <ModalDialog size='sm' kind='black' open={isOpen} onClose={handleDecline}>
            <ModalHeader hideButton>
                <h4 className='d-4'>{title}</h4>
            </ModalHeader>
            <ModalBody>{text}</ModalBody>
            <ModalFooter className={styles.footer}>
                <Button key='0' onClick={handleDecline}>
                    {cancelText}
                </Button>
                <Button key='1' kind='dangerous' onClick={handleAccept}>
                    {acceptText}
                </Button>
            </ModalFooter>
        </ModalDialog>
    );
};

export default memo(LeaveModal);
